<template>
  <div class="background">
    <h1 class="center">Resume</h1>

    <!-- The Timeline -->
    <div class="timeline center">
      <div class="container left">
        <div class="content">
          <h1 style="color: Black; ">High School Education</h1>
          <h2 style="color: Black; font-size: 20px">2015-2020</h2>
          <p style="color: Black">I went to highschool at Oakleyhouse High school in Diepriver.And I matriculated in 2020 with a deploma pass.

</p>
        </div>
      </div>
      <div class="container right">
        <div class="content">
          <h1 style="color: Black;">SPCA-Volunteerism</h1>
          <h2 style="color: Black;">2019-2021</h2>
          <p style="color: Black">I worked at the GrassyPark SPCA doing volunteer work from 2019-2021.</p>
        </div>
      </div>
      <div class="container left">
        <div class="content">
          <h1 style="color: Black;">
            Life Choices Coding Bootcamp
          </h1>
          <h2 style="color: Black; font-size: 20px">2021-2022</h2>
          <p style="color: Black">I am studying to be a fullstack developer at Life Choices Academy.</p>
        </div>
      </div>
    </div>
  </div>
  <!-- Skill -->
  <h1>Skills</h1>
  
</template>

<script>
export default {};
</script>

<style scoped>

h1{
  font-weight: 900;
  font-size: 26px;
}

body {
  background-color: #1c1c1c;
  font-family: Helvetica, sans-serif;
  overflow-x: hidden;
}

.timeline {
  position: relative;
  width: 80%;
  margin-left: 130px !important;
}

.timeline::after {
  content: "";
  position: absolute;
  width: 6px;
  background-color: white;
  top: 0;
  bottom: 0;
  left: 50%;
  margin-left: -3px;
}

.container {
  padding: 10px 40px;
  position: relative;
  background-color: inherit;
  width: 50%;
}

.container::after {
  content: "";
  position: absolute;
  width: 25px;
  height: 25px;
  right: -17px;
  background-color: white;
  border: 4px solid #ff9f55;
  top: 15px;
  border-radius: 50%;
  z-index: 1;
}

.left {
  left: 0;
}
.center {
  margin: auto !important;
}

.right {
  left: 50%;
}

.left::before {
  content: " ";
  height: 0;
  position: absolute;
  top: 22px;
  width: 0;
  z-index: 1;
  right: 30px;
  border: medium solid white;
  border-width: 10px 0 10px 10px;
  border-color: transparent transparent transparent white;
}

.right::before {
  content: " ";
  height: 0;
  position: absolute;
  top: 22px;
  width: 0;
  z-index: 1;
  left: 30px;
  border: medium solid white;
  border-width: 10px 10px 10px 0;
  border-color: transparent white transparent transparent;
}

.right::after {
  left: -16px;
}

.content {
  padding: 20px 30px;
  background-color: white;
  position: relative;
  border-radius: 6px;
}

@media screen and (max-width: 600px) {
  .timeline::after {
    left: 31px;
  }

  .container {
    width: 100%;
    padding-left: 70px;
    padding-right: 25px;
  }

  .container::before {
    left: 60px;
    border: medium solid white;
    border-width: 10px 10px 10px 0;
    border-color: transparent white transparent transparent;
  }

  .left::after,
  .right::after {
    left: 15px;
  }

  .right {
    left: 0%;
  }
}

.background {
  object-fit: contain;
  text-align: center;
  background-color: rgb(99, 0, 99);
  margin: 40px !important;
  border: rebeccapurple 8px solid;
  border-radius: 25px;
  overflow-y:scroll !important;
}
.container[data-v-bbd0c4a8]::after {
    content: "";
    position: absolute;
    width: 25px;
    height: 25px;
    right: -13px;
    background-color: white;
    border: 4px solid #ff9f55;
    top: 15px;
    border-radius: 50%;
    z-index: 1;
}
/* Skills */
/* Style tab links */
.tablink {
  background-color: red;
  color: white;
  float: left;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 14px 16px;
  font-size: 17px;
  width: 25%;
}

.tablink:hover {
  background-color: #777;
}

/* Style the tab content (and add height:100% for full page content) */
.tabcontent {
  color: white;
  display: none;
  padding: 100px 20px;
  height: 100%;
}

#Home {
  background-color: red;
}
#News {
  background-color: purple;
}
#Contact {
  background-color: red;
}
#About {
  background-color: purple;
}


</style>
